"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractType = void 0;
var ContractType;
(function (ContractType) {
    ContractType["TEMPORARY"] = "TEMPORARY";
    ContractType["PERMANENT"] = "PERMANENT";
})(ContractType || (exports.ContractType = ContractType = {}));
